var $e50a9a48739b90e1$exports = {};
$e50a9a48739b90e1$exports = {
  "decrease": function decrease(args) {
    return "Reducir ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Aumentar ".concat(args.fieldLabel);
  },
  "numberField": "Campo de n\xFAmero"
};
export { $e50a9a48739b90e1$exports as default };